webpackJsonp([114276838955818,60335399758886],{

/***/ 168:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(235);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(168);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(33);
	var isArguments = __webpack_require__(32);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(42);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(31);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(39);
	
	var _HelmetConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(34));
	var shallowEqual = _interopDefault(__webpack_require__(43));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _githubIconInverted = __webpack_require__(357);
	
	var _githubIconInverted2 = _interopRequireDefault(_githubIconInverted);
	
	var _kodeklubben_tolinjers_logo = __webpack_require__(358);
	
	var _kodeklubben_tolinjers_logo2 = _interopRequireDefault(_kodeklubben_tolinjers_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navbar = function Navbar() {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar is-transparent' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-brand' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', className: 'navbar-item' },
	          _react2.default.createElement(
	            'figure',
	            { className: 'image' },
	            _react2.default.createElement('img', { src: _kodeklubben_tolinjers_logo2.default, alt: 'Kodeklubben Ringerike', style: { width: '299px' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-burger' },
	          _react2.default.createElement(
	            'a',
	            {
	              role: 'button',
	              'class': 'navbar-burger',
	              'aria-label': 'menu',
	              'aria-expanded': 'false'
	            },
	            _react2.default.createElement(
	              'span',
	              { 'aria-hidden': 'true' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'navbar-item', to: '/about' },
	                '< Om oss >'
	              ),
	              ' '
	            ),
	            _react2.default.createElement(
	              'span',
	              { 'aria-hidden': 'true' },
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'navbar-item',
	                  href: 'http://www.paraproduksjoner.no/kode/',
	                  target: '_blank'
	                },
	                '< Webprogrammering >'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-start' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'navbar-item', to: '/about' },
	          '< Om oss >'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'navbar-item',
	            href: 'http://www.paraproduksjoner.no/kode/',
	            target: '_blank'
	          },
	          '< Webprogrammering >'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-end' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'navbar-item',
	            href: 'https://github.com/kkringerike',
	            target: '_blank',
	            rel: 'noopener noreferrer'
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'icon' },
	            _react2.default.createElement('img', { src: _githubIconInverted2.default, alt: 'Github' })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Navbar;
	module.exports = exports['default'];

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Navbar = __webpack_require__(234);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	__webpack_require__(351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Kodeklubben Ringerike' }),
	    _react2.default.createElement(_Navbar2.default, null),
	    _react2.default.createElement(
	      'div',
	      null,
	      children()
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-96f8b39da0a3925b23dc.js